import { Pin, Phone, MessageCircle } from "lucide-react";

export const DEFAULT_NOTICE = {
  title: "Pagamento online in arrivo",
  text: "Prenota pure online: paghi comodamente in sede al ritiro, in contanti o con carta (POS). Nessun anticipo.",
};

export const PaymentNotice = ({ cfg, className = "" }) => {
  if (!cfg || cfg.online_payments) return null;
  const wa = (cfg.whatsapp || "").replace(/\D/g, "");
  return (
    <div className={`relative max-w-md -rotate-1 hover:rotate-0 transition-transform duration-300 ${className}`} data-testid="payment-notice">
      <Pin className="absolute -top-3 left-1/2 -translate-x-1/2 w-6 h-6 text-[#E63946] fill-[#E63946] rotate-12 drop-shadow" />
      <div className="bg-[#FDE68A] text-[#3B2F0B] rounded-sm px-5 pt-5 pb-4 shadow-[0_12px_30px_-10px_rgba(0,0,0,0.6)]">
        <div className="font-display font-extrabold uppercase text-sm tracking-wide" data-testid="payment-notice-title">{cfg.notice?.title || DEFAULT_NOTICE.title}</div>
        <p className="text-sm mt-1.5 leading-snug whitespace-pre-line" data-testid="payment-notice-text">{cfg.notice?.text || DEFAULT_NOTICE.text}</p>
        {(cfg.phone || wa) && (
          <div className="flex flex-wrap gap-3 mt-3 text-xs font-semibold">
            {cfg.phone && <a href={`tel:${cfg.phone.replace(/\s/g, "")}`} className="inline-flex items-center gap-1 underline underline-offset-2" data-testid="payment-notice-phone"><Phone className="w-3.5 h-3.5" />{cfg.phone}</a>}
            {wa && <a href={`https://wa.me/${wa}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 underline underline-offset-2" data-testid="payment-notice-whatsapp"><MessageCircle className="w-3.5 h-3.5" />WhatsApp</a>}
          </div>
        )}
      </div>
    </div>
  );
};
